<template>
  <div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-md-5 col-lg-6 col-xl-4 px-lg-6 my-5 align-self-center">
          <div><img v-if="$store.state.darkMode" src="../assets/logo.png" style="width:250px" class="mx-auto d-block mb-3" alt="aqfer logo" />
          <img v-else src="../assets/logo2.png" style="width:250px" class="mx-auto d-block mb-3" alt="aqfer logo" /></div>
          <!-- Heading -->
          <!-- <h1 class="display-4 text-center mb-3">Sign in</h1> -->

          <!-- Subheading -->
          <p class="text-muted text-center">Client and Administration Portal</p>

          <!-- Submit -->
          <button v-if="$store.state.cognitoUrl" id="login-btn-cognito" @click="loginClicked('cognito')" class="btn btn-lg w-100 btn-secondary mb-3"
            :disabled="isMailLoginClicked">
            <div v-if="isMailLoginClicked" class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <span v-else>
              <i class="fa fa-envelope me-3"></i>
              Sign in with Email
            </span>
          </button>

          <!-- Submit -->
          <button id="login-btn" @click="loginClicked('google')" class="btn btn-lg w-100 btn-primary mb-3"
            :disabled="isGoogleLoginClicked">
            <div v-if="isGoogleLoginClicked" class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <span v-else>
              <div class="gsi-material-icon-wrapper">
                <div class="gsi-material-button-icon">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                    xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                    <path fill="#EA4335"
                      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z">
                    </path>
                    <path fill="#4285F4"
                      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z">
                    </path>
                    <path fill="#FBBC05"
                      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z">
                    </path>
                    <path fill="#34A853"
                      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z">
                    </path>
                    <path fill="none" d="M0 0h48v48H0z"></path>
                  </svg>
                </div>
              </div>
              Sign in with Google
            </span>
          </button>

          <p class="text-center mb-3">
            <a href="#" @click.prevent="openOrgLoginModal">
              <small>Looking for your organization's custom login?</small>
            </a>
          </p>

          <!-- Link -->
          <p class="text-center">
            <small class="text-muted text-center">
              Need Access? Contact us at <a href="mailto:support@aqfer.com">support@aqfer.com</a>.<br />
              Version {{ appVersion }}
            </small>
          </p>
        </div>

        <div
          ref="orgLoginModal"
          class="modal fade"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div class="modal-content">
              <form @submit.prevent="submitOrgLogin">
                <div class="modal-header">
                  <h4 class="modal-title">Organization Sign-in</h4>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <label for="org-login-cid" class="form-label">Organization ID (CID)</label>
                  <input
                    id="org-login-cid"
                    ref="cidInput"
                    v-model="cidInput"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': orgLoginError }"
                    placeholder="e.g. c900"
                    autocomplete="off"
                  />
                  <div v-if="orgLoginError" class="invalid-feedback">{{ orgLoginError }}</div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                  <button type="submit" class="btn btn-primary" :disabled="!cidInput.trim() || orgLoginLoading">
                    <span v-if="orgLoginLoading" class="spinner-border spinner-border-sm me-1" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </span>
                    Continue
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-7 col-lg-6 col-xl-8 d-none d-lg-block">
          <!-- Image -->
          <div class="bg-cover h-100 min-vh-100 mt-n1 me-n3" :style="{
            'background-image':
              'url(' + require('../assets/back2.jpg') + ')',
          }"></div>
        </div>
      </div>
      <!-- / .row -->
    </div>
  </div>
</template>

<script>
import BootstrapModal from 'bootstrap/js/dist/modal';
import axios from 'axios';

export default {
  name: "Login",
  data() {
    return {
      isMailLoginClicked: false,
      isGoogleLoginClicked: false,
      appVersion: process.env.VUE_APP_VERSION,
      cidInput: '',
      orgModal: null,
      orgLoginLoading: false,
      orgLoginError: ''
    }
  },
  mounted() {
    // Visiting the generic login screen clears any sticky CID-login preference
    // so subsequent logouts return here, not to an old org login page.
    localStorage.removeItem('cidLogin');
    this.orgModal = new BootstrapModal(this.$refs.orgLoginModal);
    this.$refs.orgLoginModal.addEventListener('shown.bs.modal', () => {
      if (this.$refs.cidInput) this.$refs.cidInput.focus();
    });
  },
  beforeUnmount() {
    if (this.orgModal) this.orgModal.dispose();
  },
  methods: {
    loginClicked(method) {
      if (method === 'cognito') {
        this.isMailLoginClicked = true;
      } else if (method === 'google') {
        this.isGoogleLoginClicked = true;
      }
      this.$store.dispatch('login', method);
    },
    openOrgLoginModal() {
      this.cidInput = '';
      this.orgLoginError = '';
      this.orgLoginLoading = false;
      this.orgModal.show();
    },
    submitOrgLogin() {
      const cid = this.cidInput.trim();
      if (!cid) return;
      this.orgLoginLoading = true;
      this.orgLoginError = '';
      const authUrl = this.$store.state.authUrl;
      const loginConfigUrl = `${authUrl}/v1/cids/${encodeURIComponent(cid)}/login-config`;
         axios.get(loginConfigUrl, {
           validateStatus: (status) => status === 200
      })
        .then((response) => {
            const finalUrl = response?.request?.responseURL;
            if (finalUrl && finalUrl !== loginConfigUrl) {
              throw new Error('Redirected login-config response');
            }
          const target = `/${encodeURIComponent(cid)}/login`;
          const modalEl = this.$refs.orgLoginModal;
          const onHidden = () => {
            modalEl.removeEventListener('hidden.bs.modal', onHidden);
            this.$router.push(target);
          };
          modalEl.addEventListener('hidden.bs.modal', onHidden);
          this.orgModal.hide();
        })
        .catch((error) => {
            const status = error.response?.status;
            if (status === 404 || status === 410) {
              this.orgLoginError = 'Custom login not found. Please go back and login using your email/google.';
            } else {
              this.orgLoginError = 'Unable to validate custom login right now. Please try again or login using your email/google.';
            }
            })
        .finally(() => {
          this.orgLoginLoading = false;
        });
    }
  }

};
</script>

<style scoped>
.gsi-material-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  background: white;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}

.gsi-material-button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
}

/* Add this to properly align the icon with text */
button span {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Make sure the SVG is properly sized */
.gsi-material-button-icon svg {
  width: 18px;
  height: 18px;
}
</style>
